module.exports = __webpack_public_path__ + "img/triangle-95.5da56f77.gif";